<!-- GoogleMap.vue -->
<template>
    <div class="google-map-responsive">
      <iframe
        frameborder="0"
        style="border:0"
        :src="mapUrl"
        allowfullscreen
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
        aria-label="Google Map"
      ></iframe>
    </div>
  </template>
  
  <script>
  export default {
    name: 'GoogleMap',
    props: {
        address: {
            type: String,
            required: true
        }
    },
    computed: {
      mapUrl() {
        const encodedAddress = encodeURIComponent(this.address);
        return `https://www.google.com/maps/embed/v1/place?key=AIzaSyCE60afA6sO7P_2Dsy9j6o9ymsb8t6Z57s&q=${encodedAddress}`;
      }
    }
  }
  </script>
  
  <style scoped>
  .google-map-responsive {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    height: 0;
    overflow: hidden;
    margin-bottom: 0;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
  .google-map-responsive iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
    border-radius: 8px;
  }
  </style>